import { tViews } from "../../../../../utils/table";

export const getColumnsClientsName = () => [
  {
    prop: "site_name",
    name: tViews('clientSitesColHeader'),
    size: 80
  },
  {
    prop: "source_ip",
    name: tViews('clientIpColHeader'),
    size: 80
  },
  {
    prop: "top_used_apps",
    name: tViews('clientsTopAppsColHeader'),
    size: 150
  },
  {
    prop: "usage",
    name: tViews('userDataUsage'),
    size: 100
  }
];

// For backward compatibility - consumers should migrate to getColumnsClientsName()
export const columnsClientsName = getColumnsClientsName();

export const getSourceClients = data => {
  return data.map(element => {
    return {
      application: element.site_name,
      source_ip: element.source_ip,
      top_used_apps: element.top_used_apps,
      userDataUsage: element.userDataUsage
    };
  });
};
